import axios from 'axios'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useOutsideClick } from '../../utils/hooks'
const server = process.env.REACT_APP_SERVER_URL

const RawAutoComplete: React.FC<RawAutoCompleteProps> = ({
  url,
  bodyGet,
  queryParam,
  selectedValue,
  setSelectedValue,
  classes = 'col-span-12',
  callBackRequest = () => {},
  label = 'Artículo',
  outsideParams = [],
  defaultSearch = "",
  placeholder = "",
  type = 'single',
  multipleValues = []
}) => {
  const { addAlert } = useSnackBars()
  const [showValues, setShowValues] = useState<boolean>(false)
  const [arrayOfValues, setArrayOfValues] = useState<any[]>([])

  const myRef = useRef<HTMLInputElement | null>(null)
  const wrapperRef = useRef(null)

  useOutsideClick(wrapperRef, () => setShowValues(false))

  // Refactorizar para que el componente solo reciba como parametro
  // la funcion fetch, dejando la responsabilidad de los values y los queryparams
  // al consumidor. Al momento de la escritura, este componente solo se usaba en ensamblados
  let values = {
    '0': (value) => outsideParams.length === 0 ? `?${queryParam}=${value}` : `?${[...outsideParams, `${queryParam}=${value}`].join("&")}`,
    '1': () => outsideParams.length === 0 ? '/' : `?${outsideParams.join("&")}`,
  }

  const getItems = async (value: string = ''): Promise<void> => {
    try {
      // addAlert({
      //   message: 'Cargando...',
      //   status: 'loading',
      // })


      if (type === 'multiple') { 

        let response = await Promise.all(multipleValues.map((v, i) => axios.get(`${server}/${v.url}?${v?.queryParam}=${value}`)))
        let valueArray = response.reduce((a, b, i) => {
          a.push(...b.data[multipleValues[i].bodyGet] as any)
          return a
        }, [] as any)
        callBackRequest(valueArray)
        setArrayOfValues(valueArray)
        return
      }

      if (typeof url === 'object') {

        // let urlMap = await url.map(async (v, i) => {
        //   return await axios.get(`${server}/${v}?${outsideParams[i]}`)
        // })
      
      if (value === '') {
        let response = await Promise.all(url.map((v, i) => axios.get(`${server}/${v}?${outsideParams[i]}`)))
        let valueArray = response.reduce((a, b) => {
          a.push(...b.data[bodyGet] as any)
          return a
        }, [] as any)
        callBackRequest(valueArray)
        setArrayOfValues(valueArray)
      } else {
        let response = await Promise.all(url.map((v, i) => axios.get(`${server}/${v}?${outsideParams[i]}&search=${value}`)))
        let valueArray = response.reduce((a, b) => {
          a.push(...b.data[bodyGet] as any)
          return a
        }, [] as any)
        console.log("VALUE 2", valueArray)
        callBackRequest(valueArray)
        setArrayOfValues(valueArray)
      }

      // let response = await Promise.all([axios.get(`${server}/accounting/simple-search?element=REVENUE&search=bru`), axios.get(`${server}/accounting/simple-search?element=REVENUE&search=bru`)])
      // console.log("RESPONSE...", response)

      } else {
        let resp = await axios.get(
          `${server}/${url}${values[+(value === '')](value)}`
        )
        callBackRequest(resp.data[bodyGet])
        setArrayOfValues(resp.data[bodyGet])
      }

      // resp = await axios.get(
      //   `${server}/${url}${values[+(value === '')](value)}`
      // )
      // console.log("array values", resp.data[bodyGet])
      // callBackRequest(resp.data[bodyGet])
      // setArrayOfValues(resp.data[bodyGet])
      // addAlert({
      //   message: 'Ensamblados cargados',
      //   status: 'success',
      //   duration: 1000,
      // })
    } catch (error: any) {
      addAlert({
        message:
          error?.response?.data?.message ||
          'Error al cargar artículos ensamblados',
        status: 'error',
      })
      return
    }
  }

  useEffect(() => {
    getItems(defaultSearch)
    
    // setTimeout(() => {
    //   if (defaultSearch && myRef && myRef.current) {
    //     myRef.current.value = defaultSearch
    //   }
    // }, 500)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, defaultSearch])

  useEffect(() => {
    if (defaultSearch && arrayOfValues.length > 0) {
      onChangeValueAutocomplete(arrayOfValues[0])
    }
  }, [defaultSearch, arrayOfValues])
  

  const onChangeFetch = (value: string): void => {
    if (myRef.current?.value !== selectedValue?.name) {
      setSelectedValue(null)
    }
    getItems(value)
  }

  const onChangeValueAutocomplete = (value: any): void => {
    myRef.current && (myRef.current.value = (value.name || value.businessName))
    setShowValues(false)
    setSelectedValue(value)
  }

  useEffect(() => {
    console.log("SELECTED VALUE", selectedValue)
    if (!selectedValue && myRef.current) {
        myRef.current!.value = ""
    }
  }, [selectedValue])
  

  return (
    <>
      <div className={classes} ref={wrapperRef}>
        <div className="flex flex-col">
          <label className="font-medium text-primary-900 text-xs dark:text-white my-1">
            {label}
          </label>
          <input
            className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
            type="text"
            onFocus={() => setShowValues(true)}
            onChange={(e) => onChangeFetch(e.target.value)}
            ref={myRef}
            placeholder={placeholder}
          />
        </div>

        {arrayOfValues.length > 0 && showValues && (
          <AnimatePresence>
            <motion.div
              className="w-52 max-h-40 rounded text-xs px-2 shadow-md absolute bg-white dark:bg-gray-800 z-50 border-gray-100 border-solid border-1 overflow-y-auto"
              initial="closed"
              animate="open"
              exit="closed"
              transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
              variants={{
                open: { opacity: 1, height: 'max-content' },
                closed: { opacity: 0, height: 60 },
              }}
            >
              {arrayOfValues.map((value, i) => (
                <div
                  key={i}
                  className="cursor-pointer my-1"
                  onClick={() => onChangeValueAutocomplete(value)}
                >
                  {value?.name || value?.businessName}
                </div>
              ))}
            </motion.div>
          </AnimatePresence>
        )}
      </div>
    </>
  )
}

interface RawAutoCompleteProps {
  url: string | string[]
  bodyGet: string
  queryParam: string
  onSelect?: Function
  selectedValue: any
  setSelectedValue: Function
  classes?: string
  callBackRequest?: Function
  label?: string
  outsideParams?: string[]
  defaultSearch?: string
  placeholder?: string
  type?: 'multiple' | 'single'
  multipleValues?: any[]
}

export default RawAutoComplete
